"use client";

import { TOP_NAV_Z_INDEX } from "@/app/layout/GlobalNav";
import { Backdrop } from "@mui/material";
import { createContext, useCallback, useContext, useState } from "react";

interface BodyBackdropContext {
  setBackdropOpen: (open: boolean) => void;
  backdropOpen: boolean;
}

let isBackdropOpenGlobal = false;

const bodyBackdropContext = createContext<BodyBackdropContext | undefined>({
  setBackdropOpen: () => {
    throw new Error("setBackdropOpen not implemented");
  },
  backdropOpen: false,
});

export function BodyBackdropProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const [backdropOpen, setBackdropOpen] = useState(isBackdropOpenGlobal);
  const handleSetBackdropOpen = useCallback((open: boolean) => {
    isBackdropOpenGlobal = open;
    setBackdropOpen(open);
  }, []);
  const contextValue: BodyBackdropContext = {
    setBackdropOpen: handleSetBackdropOpen,
    backdropOpen,
  };

  return (
    <bodyBackdropContext.Provider value={contextValue}>
      {children}
      <Backdrop
        open={backdropOpen}
        onClick={() => setBackdropOpen(false)}
        sx={{
          zIndex: TOP_NAV_Z_INDEX - 20,
          backgroundColor: "rgba(255, 255, 255, 0.7)",
        }}
      />
    </bodyBackdropContext.Provider>
  );
}

export function useBodyBackdrop() {
  const context = useContext(bodyBackdropContext);
  if (!context) {
    throw new Error(
      "useBodyBackdrop must be used within a BodyBackdropProvider"
    );
  }
  return context;
}
